import { render } from "./CreateArtistForm.vue?vue&type=template&id=f0b9adfa"
import script from "./CreateArtistForm.vue?vue&type=script&lang=js"
export * from "./CreateArtistForm.vue?vue&type=script&lang=js"

import "./CreateArtistForm.vue?vue&type=style&index=0&id=f0b9adfa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__